import { useQuery } from '@tanstack/react-query';

import { fetchMrrByProduct, fetchMrrSeries, type MrrSeriesParams } from '../lib/reports-api';

export const reportsKeys = {
  all: ['reports'] as const,
  series: (params: MrrSeriesParams) => [...reportsKeys.all, 'mrr-series', params] as const,
  byProduct: () => [...reportsKeys.all, 'mrr-by-product'] as const,
};

export function useMrrSeries(params: MrrSeriesParams = {}) {
  return useQuery({
    queryKey: reportsKeys.series(params),
    queryFn: () => fetchMrrSeries(params),
    staleTime: 60_000,
  });
}

export function useMrrByProduct() {
  return useQuery({
    queryKey: reportsKeys.byProduct(),
    queryFn: () => fetchMrrByProduct(),
    staleTime: 60_000,
  });
}
